var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-block'),_c('div',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('footer-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }